import { action as apiAction } from 'api/Api'
import sweetalert from 'sweetalert2'
import {
  removeUser
} from 'store/redux/userGroups'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  userId: number
  userGroupId: number
}

export default (payload: Payload) => async (dispatch, getState) => {
  const { userId, userGroupId } = payload

  const state = getState()

  const userGroup = state.kanbo.userGroups[userGroupId]

  let currentUserIndex
  if (userGroup) {
    currentUserIndex = userGroup.users.indexOf(userId)
  }

  let optimisticAction
  if (currentUserIndex >= 0) {
    optimisticAction = optimisticDispatch(dispatch, removeUser({
      id: userGroupId,
      userId
    }))
  }

  try {
    await apiAction('RemoveUserFromGroup', {
      userId,
      groupId: userGroupId
    })

    optimisticAction?.commit()
  } catch (error) {
    optimisticAction?.revert()

    if (error.code === 501) {
      try {
        await sweetalert({
          type: 'info',
          text: getState().kanbo.locale.messages['USER_REMAINS_RESPONSIBLE_ERROR']
        })
      } catch (e) {}
    } else if (error.code === 507) {
      try {
        await sweetalert({
          type: 'info',
          text: getState().kanbo.locale.messages['USER_LAST_OWNER_ERROR']
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}

